import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, setDisplayName } from 'recompose';

import {
  currentServiceRequestSelector,
} from 'redux/serviceRequests/selectors';

import immutableToJS from 'utils/immutableToJS';

/* istanbul ignore next */
const withConnectedData = (WrappedComponent) => {
  function Container(props) {
    return (
      <WrappedComponent {...props} />
    );
  }

  Container.propTypes = {
    info: PropTypes.shape({
      complaint: PropTypes.shape({
        code: PropTypes.string,
        description: PropTypes.string,
      }),
      description: PropTypes.string,
    }).isRequired,
  };

  function mapStateToProps(state) {
    return {
      info: currentServiceRequestSelector(state),
    };
  }

  return compose(
    setDisplayName('ServiceRequestComplaintContainer'),
    connect(mapStateToProps),
    immutableToJS,
  )(Container);
};

export default withConnectedData;



// WEBPACK FOOTER //
// ./compositions/ComplaintWidget/ServiceRequestComplaintContainer.js